export const PROENEM_FALLBACK_URL = 'https://estude.proenem.com.br/';

function resolveFallbackUrl() {
  const configuredUrl = document
    .getElementById('js-setup-wizard')
    ?.getAttribute('data-proenem-url');

  if (configuredUrl) {
    return configuredUrl.endsWith('/') ? configuredUrl : `${configuredUrl}/`;
  }

  return PROENEM_FALLBACK_URL;
}

function resolveSourcePath(sourcePath) {
  if (typeof sourcePath === 'string' && sourcePath.trim()) {
    return sourcePath.trim();
  }

  if (typeof window !== 'undefined' && window.location?.pathname) {
    return window.location.pathname + (window.location.search || '');
  }

  return undefined;
}

// Requests a one-time SSO redirect URL for the ProEnem platform.
// Returns the signed redirect URL on success. On failure, reports to Rollbar
// and returns null so the caller can surface the error instead of sending the
// user to ProEnem without authentication.
export async function fetchProenemRedirectUrl(sourcePath) {
  try {
    const payload = {};
    const resolvedSourcePath = resolveSourcePath(sourcePath);

    if (resolvedSourcePath) {
      payload.source_path = resolvedSourcePath;
    }

    const response = await fetch('/api/user/auth/proenem', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document
          .querySelector('meta[name="csrf-token"]')
          ?.getAttribute('content')
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      Rollbar.error('Erro ao gerar redirect ProEnem', {
        status: response.status,
        error: data.error
      });
      return null;
    }

    if (!data.redirect_url) {
      Rollbar.error('Erro ao gerar redirect ProEnem: redirect_url ausente');
      return null;
    }

    return data.redirect_url;
  } catch (err) {
    Rollbar.error('Erro ao gerar redirect ProEnem', err);
    return null;
  }
}

export function proenemFallbackUrl() {
  return resolveFallbackUrl();
}
